import { Box } from "@mui/material"
import EmployeeInfo from "../employeeInfo/employeeInfoCM"

export const ShareEmployeeProfile = () => {
    return (
        <EmployeeInfo config={{ personalInfo: true }} />
    )
}